import { DraggableProvided, DraggableStateSnapshot } from "@hello-pangea/dnd";
import { theme } from "../../constants/StyledComponents";
import { FontWeightEnum, IconSizeEnum } from "../../types/AppTypes";
import { IconManager } from "../core/IconManager/IconManager";
import { BodyTyp } from "../Typography/Typography";
import { BadgeIndex } from "../BadgeIndex/BadgeIndex";
import { ModalDeleteItem } from "../../screens/Management/ManagementTabs/ManageCMSheet/CMSheetMenu/ManageInternalGrade/PathsGrades/ModalDeleteItem";
import { CheckIconContainer, StyledItem } from "./PathGradeItem.styled";
import TextInput from "../core/TextInput/TextInput";
import { ReactComponent as EditIcon } from "../../icons/pencil.svg";
import { ReactComponent as BinIcon } from "../../icons/bin.svg";
import { ReactComponent as CheckIcon } from "../../icons/check.svg";
import { ReactComponent as GridIcon } from "../../icons/dotsGrid.svg";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import {
  DELETE_GRADE_1_LABEL,
  DELETE_GRADE_LABEL,
  DELETE_GRADE_PATH_2_LABEL,
  DELETE_PATH_LABEL,
} from "../../constants/Dictionary";
import {
  GenericPathGradeItem,
  TypeItemPrimary,
} from "../../screens/Management/ManagementTabs/ManageCMSheet/CMSheetMenu/ManageInternalGrade/PathsGrades/ManagePathsGrades";
import { useState } from "react";
import { InputSizes } from "../core/Input/Input";

interface GradePathItemProps {
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  editingId: {
    id: number;
    type: string;
  } | null;
  isEditable: boolean;
  newItemIds: number | null;
  item: GenericPathGradeItem;
  newItemName: string;
  index: number;
  handleEdit: (id: number, typeItemPrimary: TypeItemPrimary) => void;
  handleSave: (id: number, typeItemPrimary: TypeItemPrimary) => void;
  handleDelete: (id: number, typeItemPrimary: TypeItemPrimary) => void;
  handleInputChange: (text: string) => void;
  typeItemPrimary: TypeItemPrimary;
  handleCancel: (
    item: GenericPathGradeItem,
    type: TypeItemPrimary,
    isNewItem: boolean,
  ) => void;
  isUpdatingAnItem: boolean;
  editingChildrenItem: boolean;
  activeChildrenItem: boolean;
}

export const GradePathItem = ({
  provided,
  snapshot,
  editingId,
  isEditable,
  newItemIds,
  item,
  newItemName,
  index,
  handleDelete,
  handleEdit,
  handleSave,
  handleCancel,
  handleInputChange,
  typeItemPrimary,
  isUpdatingAnItem,
  editingChildrenItem,
  activeChildrenItem,
}: GradePathItemProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <StyledItem
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      $isDragging={snapshot.isDragging}
      $isDragDisabled={
        !isEditable ||
        (editingId ? editingId.id !== item.id : false) ||
        editingChildrenItem ||
        activeChildrenItem
      }
      $isNew={newItemIds === item.id && editingId?.type === typeItemPrimary}
      $isEditable={isEditable}
      $type={typeItemPrimary}
    >
      {(editingId?.id === item.id && editingId.type === typeItemPrimary) ||
      (editingId === null && newItemIds === item.id) ? (
        <>
          <div className="item-input">
            <IconManager color={theme.colors.purple} size={IconSizeEnum.SMALL}>
              <GridIcon />
            </IconManager>
            <TextInput
              value={newItemName}
              maxLength={255}
              onChange={handleInputChange}
              inputSize={InputSizes.SMALL}
            />
          </div>
          <CheckIconContainer
            $isActive={!!newItemName}
            onClick={() =>
              newItemName ? handleSave(item.id, typeItemPrimary) : {}
            }
          >
            <IconManager
              size={IconSizeEnum.SMALL}
              color={newItemName ? theme.colors.white : theme.colors.grey_4}
            >
              <CheckIcon />
            </IconManager>
          </CheckIconContainer>
          <IconManager
            size={IconSizeEnum.SMALL}
            color={theme.colors.purple}
            onClick={() =>
              handleCancel(item, typeItemPrimary, newItemIds === item.id)
            }
          >
            <CloseIcon />
          </IconManager>
        </>
      ) : (
        <>
          <div>
            {isEditable && (
              <IconManager
                color={theme.colors.purple}
                size={IconSizeEnum.SMALL}
              >
                <GridIcon />
              </IconManager>
            )}
            <BadgeIndex content={(index + 1).toString()} />
            <BodyTyp
              variant="1"
              color={theme.colors.purple}
              fontWeight={FontWeightEnum.SEMIBOLD}
            >
              {item.name}
            </BodyTyp>
          </div>
          <div>
            {isEditable && (
              <>
                <IconManager
                  size={IconSizeEnum.SMALL}
                  onClick={
                    !isUpdatingAnItem
                      ? () => handleEdit(item.id, typeItemPrimary)
                      : undefined
                  }
                  color={
                    !isUpdatingAnItem
                      ? theme.colors.purple
                      : theme.colors.grey_3
                  }
                >
                  <EditIcon />
                </IconManager>
                <IconManager
                  size={IconSizeEnum.SMALL}
                  onClick={
                    !isUpdatingAnItem ? () => setShowModal(true) : undefined
                  }
                  color={
                    !isUpdatingAnItem
                      ? theme.colors.purple
                      : theme.colors.grey_3
                  }
                >
                  <BinIcon />
                </IconManager>
              </>
            )}
            {showModal && (
              <ModalDeleteItem
                modalLabel={
                  DELETE_GRADE_1_LABEL + item.name + DELETE_GRADE_PATH_2_LABEL
                }
                title={
                  typeItemPrimary === TypeItemPrimary.PATH
                    ? DELETE_PATH_LABEL
                    : DELETE_GRADE_LABEL
                }
                isOpen={showModal}
                closeModal={() => setShowModal(false)}
                deleteItem={() => handleDelete(item.id, typeItemPrimary)}
              />
            )}
          </div>
        </>
      )}
    </StyledItem>
  );
};
